
export const GET_AGENT = 'ideal/components/GET_AGENT';
export const AGENT_RECEIVED = 'ideal/components/AGENT_RECEIVED';

